import mock from './mock'

import './chat-mock'

mock.onAny().passThrough()
